module.exports = (__webpack_require__(7079))("./src/select-all.js");